import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import FaberBasicTab from 'common/FaberComponents/basic-components/FaberTab'
import NormalText from 'common/Typography/NormalText'
import FinanceV2Tab from 'pages/Customers/sharedComponents/v2/FinanceV2Tab'
import { FinanceV2OneUser } from 'pages/Subscription/components'
import {
  GetAllGlobalUsersDetails,
  TransformedFaberUserData
} from 'types/api/faber/globalCustomers.type'
import { GetAllFaberUsersDetails } from 'types/api/faber/oneTimePack.type'

import { EventLogsPage, UserProfileV3 } from './components'
function FaberViewProfilePageV2() {
  const location = useLocation()

  const rowInformation = location.state as
    | GetAllFaberUsersDetails
    | GetAllGlobalUsersDetails

  const transformedRowInformation = useMemo(() => {
    if ('email' in rowInformation && 'msisdn' in rowInformation) {
      return {
        firstName: rowInformation.firstName,
        lastName: rowInformation.lastName,
        userID: rowInformation._id,
        userEmail: rowInformation.email,
        iccid: '',
        planStatus: rowInformation.status,
        planName: '',
        msisdn: rowInformation.msisdn,
        subscription: rowInformation.subscription,
        otpack: rowInformation.otpack,
        countryCode: '+65'
      } as TransformedFaberUserData
    } else if (
      'given_name' in rowInformation &&
      'family_name' in rowInformation
    ) {
      return {
        firstName: rowInformation.given_name,
        lastName: rowInformation.family_name,
        fullName: rowInformation.name,
        userID: rowInformation.user_id,
        userEmail: rowInformation.user_metadata?.email,
        iccid: '',
        planStatus: '',
        msisdn: rowInformation.user_metadata?.phone_number,
        countryCode: rowInformation.user_metadata?.country_code
      } as TransformedFaberUserData
    }
  }, [rowInformation])

  const allTabs = useMemo(() => {
    return [
      {
        tabTitle: 'Overview',
        tabContent: transformedRowInformation ? (
          <UserProfileV3 customerRow={transformedRowInformation} />
        ) : null,
        tabCategory: 'overview',
        passedData: rowInformation
      },
      {
        tabTitle: 'Finance',
        tabContent: transformedRowInformation ? (
          <FinanceV2OneUser customerRow={transformedRowInformation} />
        ) : null,
        tabCategory: 'finance',
        passedData: rowInformation
      },
      {
        tabTitle: 'Finance V2',
        tabContent: <FinanceV2Tab />,
        tabCategory: 'finance-v2',
        passedData: rowInformation
      },
      {
        tabTitle: 'Event Logs',
        tabContent: transformedRowInformation ? (
          <EventLogsPage customerRow={transformedRowInformation} />
        ) : null,
        tabCategory: 'logs',
        passedData: rowInformation
      }
    ]
  }, [rowInformation])

  return (
    <>
      <NormalText theme='dark' variant='h5' isBold>
        Customer Details
      </NormalText>

      <FaberBasicTab tabInfo={allTabs} />
    </>
  )
}

export default FaberViewProfilePageV2
